import { createSlice } from "@reduxjs/toolkit";
import { pipe, prop, sortBy, uniqBy } from "ramda";

const initialState = {
  broadcasts: [],
  contentItems: [],
  loadingBroadcasts: false,
  loadingContentItems: false,
  folders: [],
  loadingFolders: false,
};

const arrivideoSlice = createSlice({
  name: "arrivideo",
  initialState,
  reducers: {
    addContentItems(state, action) {
      const newItems = [...(state.contentItems || []), ...action.payload];
      state.contentItems = pipe(
        uniqBy(prop("id")),
        sortBy(prop("order")),
      )(newItems);
    },
    setBroadcasts(state, action) {
      state.broadcasts = action.payload;
    },
    setContentItems(state, action) {
      state.contentItems = action.payload;
    },
    setFolders(state, action) {
      state.folders = action.payload;
    },
    // Loading actions
    loadingBroadcasts(state) {
      state.loadingBroadcasts = true;
    },
    loadingBroadcastsDone(state) {
      state.loadingBroadcasts = false;
    },
    loadingContentItems(state) {
      state.loadingContentItems = true;
    },
    loadingContentItemsDone(state) {
      state.loadingContentItems = false;
    },
    loadingFolders(state) {
      state.loadingFolders = true;
    },
    loadingFoldersDone(state) {
      state.loadingFolders = false;
    },
  },
});

export const {
  addContentItems,
  setBroadcasts,
  setContentItems,
  setFolders,
  loadingBroadcasts,
  loadingBroadcastsDone,
  loadingContentItems,
  loadingContentItemsDone,
  loadingFolders,
  loadingFoldersDone,
} = arrivideoSlice.actions;

export default arrivideoSlice.reducer;
